// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"N_-z","categoryName":"O_-z","categoryImage":"P_-z","categoryContent":"Q_-z","bottomAligned":"R_-z"};